/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright 2022 Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useEffect, useState} from 'react';
import PageBox from "../../layouts/pageBox";
//import ImgGoogle from "../../assets/img/forms/google.png";
//import {ReactComponent as ArrowRight} from "../../assets/img/icons/arrow-right-white.svg";
//import {ReactComponent as CheckboxEmpty} from "../../assets/img/forms/checkbox-empty.svg";
//import {ReactComponent as CheckboxFull} from "../../assets/img/forms/checkbox-full.svg";
//import {ReactComponent as Email} from "../../assets/img/forms/email.svg";
//import {ReactComponent as Eye} from "../../assets/img/forms/eye.svg";
import {ReactComponent as Icon1} from "../../assets/img/login/icon1.svg";
import {ReactComponent as Icon2} from "../../assets/img/login/icon2.svg";
import {ReactComponent as Icon3} from "../../assets/img/login/icon3.svg";
import {ReactComponent as Icon4} from "../../assets/img/login/icon4.svg";
import {ReactComponent as Icon5} from "../../assets/img/login/icon5.svg";
import {ReactComponent as Icon6} from "../../assets/img/login/icon6.svg";
import {ReactComponent as Icon7} from "../../assets/img/login/icon7.svg";
import {ReactComponent as Icon8} from "../../assets/img/login/icon8.svg";
import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../../Hooks/useAuth";
import {useTranslation} from "react-i18next";
import LoginForm from "./LoginForm";
import SEO from "../../components/SEO";

const Login = () => {

    const [onComplete, setOnComplete] = useState(null);

    const user = useAuth();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const data = {
        title: '',
        subtitle: ''
    };

    useEffect( () =>{
        if(typeof user != "undefined" && user.profile.isLogged){
            navigate(`/${i18n.language}/`);
        }
    }, [] )

    useEffect( () =>{
        if(onComplete){
            if(user.profile.group_id == 2 || user.profile.group_id == 3){
                window.location = `${process.env.REACT_APP_URL}${i18n.language}/action-login-user?usertoken=${onComplete.data.user_token}`;
            }
        }
    }, [onComplete] )

    return (
        <PageBox data={data} small={true}>
            <SEO
                title={ t('meta_title.login' )}
                description={ t('meta_description.login' ) }
            />
            <div className='page-body'>
                <div className='login-row row'>

                    <div className='col-md-6 order-md-2'>
                        <div className='login hide--register'>
                            <div className='login__title'>{t('login.myAccount')}</div>

                            {/*<button className='btn btn--google btn-icon btn-block'> <img src={ImgGoogle} alt='car' /> Login with Google</button>*/}
                            {/*<div className='login__sep-text'>or login your email and password</div>*/}
                            <LoginForm onComplete={setOnComplete} />

                        </div>
                    </div>

                    <div className='col-md-6 order-md-1'>
                        <div className='loginDetails'>
                            <div className='loginDetails__title'>{t('login.loginTitle')}</div>
                            <div className='loginDetails__text'>{t('login.loginText')}</div>

                            <div className='loginDetailsIcons'>
                                <div className='loginDetailsIcons__item'><Icon1/></div>
                                <div className='loginDetailsIcons__item'><Icon2/></div>
                                <div className='loginDetailsIcons__item'><Icon3/></div>
                                <div className='loginDetailsIcons__item'><Icon4/></div>
                                <div className='loginDetailsIcons__item'><Icon5/></div>
                                <div className='loginDetailsIcons__item'><Icon6/></div>
                                <div className='loginDetailsIcons__item'><Icon7/></div>
                                <div className='loginDetailsIcons__item'><Icon8/></div>
                            </div>

                            <div className='loginDetailsBars'>
                                <div className='loginDetailsBars__item'><span> </span></div>
                                <div className='loginDetailsBars__item'><span> </span></div>
                                <div className='loginDetailsBars__item'><span> </span></div>
                            </div>

                            <div className='loginDetails__subtitle'>>{t('login.haveAccount')}</div>
                            <div className='row no-gutters'>

                                <div className='mixed-link'>
                                    {/*<div className='mixed-link__text'>{t('login.ifFree')}</div>*/}
                                    <Link to={`/${i18n.language}/register`} className='mixed-link__link'>{t('login.freeAccountLink')}</Link>
                                </div>

                                {/*<div className='mixed-link'>*/}
                                {/*    <div className='mixed-link__text'>{t('login.ifDismantler')}</div>*/}
                                {/*    <Link to={`/${i18n.language}/pricing`} className='mixed-link__link'>{t('login.dismantlerLink')}</Link>*/}
                                {/*</div>*/}

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </PageBox>
    );
};

export default Login;
